import BasicResource from '@/api/resource';

class TriggersResource extends BasicResource {

    constructor () {
        super('triggers');
    }

    publisherEventTypesForTriggers () {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/partners/event-type-for-triggers',
        });
    }

    linkPublisherApplicableTriggers (linkId, eventTypeId, params = {}) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/partners/link/${linkId}/applicable-triggers/${eventTypeId}`,
            params,
        });
    }

    updatePublisherTriggers (linkId, payload) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/link/${linkId}/triggers`,
            data: payload,
        });
    }

    eventTypesForTriggers () {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/offers/event-type-for-triggers',
        });
    }

    deleteLinkPublisherTriggersInEventTypeIds (id, data) {
        return this.client.request({
            method: 'DELETE',
            path: `/upyield/v1/partners/link/${id}/triggers`,
            data,
        });
    }

    offerApplicableTriggers (offerId, eventTypeId, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${offerId}/applicable-triggers/${eventTypeId}`,
            params,
        });
    }

    updateOfferTriggers (offerId, payload) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/offers/${offerId}/triggers`,
            data: payload,
        });
    }

    deleteOfferTriggers (offerId, payload) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/offers/${offerId}/triggers`,
            data: payload,
        });
    }

    linkApplicableTriggers (linkId, eventTypeId, params = {}) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/link/${linkId}/applicable-triggers/${eventTypeId}`,
            params,
        });
    }

    updateLinkTriggers (id, data) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/offers/link/${id}/triggers`,
            data,
        });
    }

    deleteLinkTriggersInEventTypeIds (id, data) {
        return this.client.request({
            method: 'DELETE',
            path: `/upyield/v1/offers/link/${id}/triggers`,
            data,
        });
    }
}

export default new TriggersResource;
